// src/api/homePageApi.js

// src/api/homePageApi.js

import { getErrorMessage } from "../config/errorConfig";
import { HOME_PAGE_URL } from "../config/apiConfig";

export const fetchHomePageProducts = async (filters = {}) => {
  // Use URL constructor to properly handle query params
  const url = new URL(HOME_PAGE_URL);

  // Add filters as query params
  Object.keys(filters).forEach((key) => {
    if (filters[key]) {
      url.searchParams.append(key, filters[key]);
    }
  });

  try {
    const response = await fetch(url.toString());
     if (!response.ok) {
         // Map HTTP status to user-friendly error
         let errorMessage;
         if (response.status >= 500) {
           errorMessage = getErrorMessage("API_SERVER_ERROR");
         } else if (response.status === 404) {
           errorMessage = getErrorMessage("API_NOT_FOUND");
         } else if (response.status === 429) {
           errorMessage = getErrorMessage("API_RATE_LIMITED");
         } else {
           errorMessage = getErrorMessage("API_BAD_REQUEST");
         }
   
         throw new Error(errorMessage);
       }
    const data = await response.json();
    return data;
  } catch (error) {
     if (error.message.includes("Failed to fetch")) {
      throw new Error(getErrorMessage("NETWORK_SERVER_UNREACHABLE"));
    }else{
        throw error;
    }
  }
};



